// extracted by mini-css-extract-plugin
module.exports = {"block":"block___2MKtT","isHalf":"isHalf___3fEEU","title":"title___2FlD4"};